<ng-container *transloco="let t; prefix: 'assetOverview.editDocumentModal'">
<div class="modal-header">
  <div class="modal-header__titles">
    <h5 class="modal-title">{{ t('title') }}</h5>
    <span class="modal-subtitle">{{ t('subtitle') }}</span>
  </div>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body">
  <div class="current-document">
    <span class="current-document__label">{{ t('currentDocument') }}</span>
    <div class="current-document__file">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.937 8.68C19.926 8.648 19.917 8.617 19.904 8.586C19.855 8.48 19.794 8.379 19.708 8.293L13.708 2.293C13.622 2.207 13.521 2.146 13.415 2.097C13.385 2.083 13.353 2.075 13.321 2.064C13.237 2.036 13.151 2.018 13.062 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.982 8.85 19.965 8.764 19.937 8.68ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.553 12.447 10 13 10H18L18.002 20H6Z" fill="#9FA1A4"/>
      </svg>
      <div class="current-document__info">
        <span class="current-document__name" title="{{ currentDocumentName }}">{{ currentDocumentName }}</span>
      </div>
      <button type="button" class="current-document__download" (click)="downloadDocument()"
        [disabled]="!document.downloadUrl" [title]="t('downloadDocument')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 16L16 11H13V4H11V11H8L12 16Z" fill="#9FA1A4"/>
          <path d="M20 18H4V11H2V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V11H20V18Z" fill="#9FA1A4"/>
        </svg>
      </button>
    </div>
  </div>

  <div class="form-group">
    <label class="modal-label">{{ t('complianceType') }} <span class="required">*</span></label>
    <div class="multi-select" #complianceControl>
      <div class="select-control" [class.select-control--open]="complianceDropdownOpen"
        [class.select-control--disabled]="isLoadingOptions" (click)="toggleComplianceDropdown()">
        @if (selectedCompliances.length === 0) {
          <span class="select-control__placeholder">{{ isLoadingOptions ? t('loading') : t('selectCompliances') }}</span>
        } @else {
          <div class="pill-list" (wheel)="onPillListWheel($event)">
            @for (compliance of selectedCompliances; track compliance.complianceId) {
              <span class="pill">{{ compliance.complianceName }}</span>
            }
          </div>
        }
        <i class="ph ph-caret-down select-control__caret"></i>
      </div>

      @if (complianceDropdownOpen) {
        <ul class="select-menu">
          @if (complianceOptions.length === 0) {
            <li class="select-menu__empty">{{ t('noCompliances') }}</li>
          }
          @for (compliance of complianceOptions; track compliance.complianceId) {
            <li class="select-menu__option" (click)="toggleCompliance(compliance)">
              <input type="checkbox" class="select-menu__checkbox" [checked]="isComplianceSelected(compliance)" />
              <span>{{ compliance.complianceName }}</span>
            </li>
          }
        </ul>
      }
    </div>
  </div>

  <div class="form-group">
    <label class="modal-label">{{ t('documentType') }} <span class="required">*</span></label>
    <div class="select-control select-control--readonly">
      <span>{{ isLoadingOptions ? t('loading') : documentTypeName }}</span>
    </div>
  </div>

  <div class="form-group">
    @if (!file) {
      <input type="file" accept=".pdf" hidden #fileInput (change)="onFileSelected($event)" />
      <button type="button" class="upload-btn" (click)="fileInput.click()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 19V15H16L12 10L8 15H11V19H13Z" fill="#ee2737"/>
          <path d="M7 19H9V17H7C5.346 17 4 15.654 4 14C4 12.596 5.199 11.244 6.673 10.985L7.254 10.883L7.446 10.325C8.149 8.274 9.895 7 12 7C14.757 7 17 9.243 17 12V13H18C19.103 13 20 13.897 20 15C20 16.103 19.103 17 18 17H15V19H18C20.206 19 22 17.206 22 15C22 13.12 20.695 11.538 18.944 11.112C18.507 7.67 15.56 5 12 5C9.244 5 6.85 6.611 5.757 9.15C3.609 9.792 2 11.82 2 14C2 16.757 4.243 19 7 19Z" fill="#ee2737"/>
        </svg>
        <span class="upload-btn__text">{{ t('upload') }}</span>
      </button>
    } @else {
      <div class="upload-status">
        <div class="upload-status__icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.937 8.68C19.926 8.648 19.917 8.617 19.904 8.586C19.855 8.48 19.794 8.379 19.708 8.293L13.708 2.293C13.622 2.207 13.521 2.146 13.415 2.097C13.385 2.083 13.353 2.075 13.321 2.064C13.237 2.036 13.151 2.018 13.062 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.982 8.85 19.965 8.764 19.937 8.68ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.553 12.447 10 13 10H18L18.002 20H6Z" fill="#9FA1A4"/>
          </svg>
        </div>

        <div class="upload-status__text">
          <span class="upload-status__name" title="{{ fileName }}">{{ fileName }}</span>
          @if (isUploadingTemp) {
            <div class="upload-status__progress-container">
              <div class="upload-status__progress-bar" [style.width.%]="uploadProgress"></div>
            </div>
          }
          @if (uploadSuccess) {
            <div class="upload-status__success">{{ t('uploadSuccess') }}</div>
          }
          @if (tempUploadFailed) {
            <div class="error-message">{{ t('uploadFailed') }}</div>
          }
        </div>

        @if (isUploadingTemp) {
          <div class="upload-status__percentage">{{ uploadProgress }}%</div>
        }

        <button type="button" class="upload-status__delete" (click)="removeFile()" [title]="t('removeFile')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V8H21V6H17V4C17 2.897 16.103 2 15 2H9C7.897 2 7 2.897 7 4V6H3V8H5V20ZM9 4H15V6H9V4ZM17 8L17.001 20H7V8H17Z" fill="#9FA1A4"/>
            <path d="M9 10H11V18H9V10ZM13 10H15V18H13V10Z" fill="#9FA1A4"/>
          </svg>
        </button>
      </div>
    }
  </div>

  <div class="form-group">
    <label class="modal-label">{{ t('dateOfExpiry') }} @if (expiryRequired) { <span class="required">*</span> }</label>
    <app-flatpickr-date-picker
      [value]="expiryDate"
      [dateFormat]="'Y-m-d'"
      [required]="expiryRequired"
      (valueChange)="onExpiryChange($event)">
    </app-flatpickr-date-picker>
  </div>

  <div class="modal-footer">
    <button type="button" class="cancel-btn" (click)="closeModal()" [disabled]="isSaving">{{ 'common.cancel' | transloco }}</button>
    <button type="button" class="save-btn" (click)="save()" [disabled]="!canSave">
      @if (isSaving) {
        <span class="spinner-border"></span>
      } @else {
        <span>{{ 'common.saveChanges' | transloco }}</span>
      }
    </button>
  </div>
</div>
</ng-container>
